var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1746 35.8517C51.6997 36.1741 51.1453 36.3643 50.5699 36.4024C49.9945 36.4404 49.4193 36.3249 48.9049 36.068C47.6973 35.3959 47.0465 33.82 47.0465 31.6725V25.0908C47.0465 21.9312 45.7763 19.6833 43.6513 19.073C40.0601 18.0379 37.3785 22.3716 36.3434 24.0015L29.9922 34.129V21.769C29.9216 18.9185 28.9807 17.2113 27.2007 16.7014C26.0246 16.3615 24.2603 16.5006 22.5431 19.0807L8.34292 41.5373C6.45352 37.976 5.47385 34.0145 5.48876 29.9961C5.48876 16.462 16.4663 5.45384 29.9922 5.45384C43.518 5.45384 54.5348 16.462 54.5348 29.9961V30.0657C54.5348 30.0657 54.5348 30.112 54.5348 30.1352C54.6681 32.754 53.8055 34.8397 52.1824 35.8517H52.1746ZM60.0157 30.0039V29.8725C59.9059 13.3797 46.482 0 29.9922 0C13.5024 0 0 13.4569 0 29.9961C0 46.5353 13.4553 60 29.9922 60C37.5767 59.9996 44.8726 57.1355 50.379 51.9969C50.9135 51.5008 51.228 50.8172 51.2544 50.0942C51.2808 49.3712 51.017 48.6671 50.5201 48.1344C50.2823 47.8753 49.9949 47.6651 49.6743 47.5158C49.3538 47.3665 49.0064 47.2812 48.6523 47.2647C48.2981 47.2482 47.9441 47.3008 47.6107 47.4196C47.2772 47.5384 46.9709 47.7209 46.7094 47.9567C44.3387 50.1722 41.5381 51.8929 38.4756 53.0154C35.4131 54.138 32.152 54.6393 28.888 54.4892C25.624 54.3391 22.4244 53.5408 19.4814 52.1421C16.5383 50.7435 13.9125 48.7733 11.7616 46.3499L24.5426 26.1105V35.45C24.5426 39.9382 26.3068 41.3905 27.7888 41.8154C29.2708 42.2402 31.5369 41.9467 33.9127 38.146L40.9697 26.8907C41.1892 26.5276 41.4009 26.2186 41.5891 25.9482V31.6725C41.5891 35.8671 43.2985 39.2198 46.2938 40.8729C47.6558 41.5973 49.1905 41.9473 50.7371 41.8861C52.2836 41.8249 53.785 41.3549 55.0836 40.5253C58.3769 38.4164 60.1725 34.6002 59.9843 30.0039H60.0157Z",
    fill: "url(#paint0_linear_5520_2557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5520_2557",
    x1: 13.1284,
    y1: -0.00000223867,
    x2: 52.4309,
    y2: 25.6736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmc);
export default __webpack_public_path__ + "static/media/cmc.38bf044b8f6b1b6fbc5cba23865769d8.svg";
export { ForwardRef as ReactComponent };